<template>
	<div>
		<h2>{{ id }}</h2>
		<a v-if="youtube" :href="youtube" target="_blank">youtube link</a>
		<a v-else href="#">NO YOUTUBE LINK</a>
		<a :href="genius" target="_blank">genius link</a>
		<br />
		<br />
		<button @click="fetchUri">fetch uri</button>
		<p>{{ song_uri }}</p>
		<br />
		<textarea v-model="lyrics" placeholder="lyrics" />
		<br />
		<button @click="save">
			{{ isSaving ? "SAVING..." : "SAVE" }}
		</button>
	</div>
</template>

<script>
import { song_col, translate, getDownloadUrl } from "../../../firebase";

export default {
	props: ["song", "id"],
	data() {
		return {
			youtube: "",
			genius: this.song.url,
			song_uri: "",
			lyrics: "",
			isSaving: false,
		};
	},
	mounted() {
		const youtube = this.song.media.filter((e) => e.provider === "youtube")[0];
		if (youtube) {
			this.youtube = youtube.url;
		} else this.youtube = null;
		window.open(this.song.url, "_newtab");
	},
	methods: {
		make_parsed(lyrics, trans) {
			console.log("Making parsed_lines.");
			const lyricsSplit = lyrics.split("\n").filter((l) => l && l !== "\n");
			const transSplit = trans.split("\n").filter((l) => l && l !== "\n");
			let parsed_lines = [];
			for (let i = 0; i < lyricsSplit.length; i++) {
				const en = lyricsSplit[i];
				const fr = transSplit[i];
				const split_en = en.split(" ");
				const split_fr = fr.split(" ");
				parsed_lines[i] = { en, fr, split_en, split_fr };
			}
			return parsed_lines.filter((line) => {
				if (line.en[0] === "[") return false;
				return true;
			});
		},
		impLyrics(lyrics) {
			lyrics = lyrics.replaceAll("in' ", "ing ");
			lyrics = lyrics.replaceAll("'em", "them");
			lyrics = lyrics.replaceAll("'bout", "about");
			return lyrics;
		},
		async save() {
			this.isSaving = true;
			let { song_uri, lyrics, impLyrics } = this;
			if (song_uri) {
				song_col
					.doc(this.id)
					.update({ song_uri })
					.then(() => {
						if (!lyrics) this.isSaving = false;
					});
			}
			if (lyrics) {
				lyrics = impLyrics(lyrics);
				const lyricsTrans = (await translate({ text: lyrics, to: "fr" })).data;
				console.log("TRANSLATION: ", lyricsTrans);
				const parsed_lines = this.make_parsed(lyrics, lyricsTrans);
				console.log("PARSED_LINES: ", parsed_lines);
				song_col
					.doc(this.id)
					.update({ parsed_lines })
					.then(() => (this.isSaving = false));
			}
		},
		fetchUri() {
			getDownloadUrl("/songs/" + this.song.id + ".mp3").then(
				(url) => (this.song_uri = url)
			);
		},
	},
};
</script>

<style>
a {
	font-size: 24px;
	margin: 20px;
}
input {
	margin: 42px 0;
}
textarea {
	margin: 42px 0;
}
button {
	cursor: pointer;
}
</style>
